import {
    ApolloClient,
    HttpLink,
    ApolloLink,
    InMemoryCache,
    concat,
} from '@apollo/client';

const { env, DPSBaseUrl } = window.__conf__; // apigeeToken apigeeBaseUrl

// We're excluding credentials option on local environment while session issues are looked into
const credentials = env === 'local' ? null : 'include';

const httpLink = new HttpLink({
    uri: `${DPSBaseUrl}/recommender/graphql`,
    credentials,
});

const authMiddleware = new ApolloLink((operation, forward) => {
    operation.setContext(({ headers = {} }) => ({
        headers: {
            ...headers,
            Channel: 'WEB',
            'App-Id': 'DPS',
            'Correlation-ID': sessionStorage.getItem('correlationId'),
        },
    }));

    return forward(operation);
});

export const dynamicClient = new ApolloClient({
    cache: new InMemoryCache(),
    link: concat(authMiddleware, httpLink),
});
